import React, { useEffect, useRef, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
// import Drawer from '@mui/material/Drawer';
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import { Drawer, AppBar, DrawerHeader } from "./SideMenuTheme";
import { useSelector, useDispatch } from "react-redux";
import HeaderDrawer from "../Components/HeaderDrawer";
import SideMenuItemArray from "./SideMenuItemArray";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import { json, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as ImIcons from "react-icons/im";
import * as MdIcons from "react-icons/md";
import * as BiIocns from "react-icons/bi";
import * as GiIcons from "react-icons/gi";
import * as AiIcons from "react-icons/ai";
import * as SiIcons from "react-icons/si";
import * as FcIcons from "react-icons/fc";

import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import ArticleIcon from "@mui/icons-material/Article";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { toast } from "react-toastify";

import { Outlet } from "react-router-dom";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import ShapeLineIcon from "@mui/icons-material/ShapeLine";
import logo from "../assets/img/new_logo.jpg";
import userTemImage from "../assets/img/user.jpg";

import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  setIsOpenSideMenu,
  setOpenSideSetting,
  setPathNameClicked,
  setCurrentlyOpendMenuItem,
} from "../reduxStore/SettingsReducer";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import Preload from "../Pages/Preload/Preload";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { IconButton } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AppsIcon from "@mui/icons-material/Apps";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import * as BiIcons from "react-icons/bi";
import DashboardSharpIcon from "@mui/icons-material/DashboardSharp";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";
import AppsSharpIcon from "@mui/icons-material/AppsSharp";
import SmsFailedSharpIcon from "@mui/icons-material/SmsFailedSharp";
import BookmarkAddedSharpIcon from "@mui/icons-material/BookmarkAddedSharp";
import AssignmentSharpIcon from "@mui/icons-material/AssignmentSharp";
import AppBarItems from "./Components/AppBarItems";
import PopupSearch from "./Components/PopupSearch";
import animationLogo from "../assets/img/animationLog.PNG";
import Preloading from "../Pages/Preload/Preloading";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PersonIcon from "@mui/icons-material/Person";
import InventoryIcon from "@mui/icons-material/Inventory";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import SideSetting from "./SideSetting";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import DescriptionIcon from "@mui/icons-material/Description";
import host from "../assets/js/Host";
import feHost from "../assets/js/feHost";
import { PanToolAlt } from "@mui/icons-material";
import GroupsIcon from '@mui/icons-material/Groups';
import AppListOfUpdates from "./AppListOfUpdates";
import LinkIcon from "@mui/icons-material/Link";
import BurstModeIcon from '@mui/icons-material/BurstMode';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import FolderIcon from '@mui/icons-material/Folder';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import PaidIcon from '@mui/icons-material/Paid';
import { TbTransfer } from "react-icons/tb";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import SyncProblemOutlinedIcon from '@mui/icons-material/SyncProblemOutlined';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';

const APP_CONSTANTS = {
  API_URL_IMG: `${process.env.REACT_APP_API_URL}`,
};
const cookies = new Cookies();
const tempImgURL =
  "https://images.unsplash.com/photo-1630945386735-372fbe731e3f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fHBlcG9sZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60";

export default function SideMenu() {
  const [t] = useTranslation("common");
  const location = useLocation();
  const drawerwidth = useSelector((state) => state.settingsData.drawerwidth);
  const pageTitle = useSelector((state) => state.settingsData.pageTitle);
  const sidemenutheme = useSelector((state) => state.themeData.sidemenutheme);
  const appbarTheme = useSelector((state) => state.themeData.appbar);
  const maintheme = useSelector((state) => state.themeData.appbar);
  const MainContainerRef = useRef(null);
  const open_advance_search = useSelector(
    (state) => state.settingsData.open_advance_search
  );
  const pathnamecliked = useSelector((state) => state.settingsData.pathnamecliked)
  const copyOfcurrentOpenMenuItem = useSelector(
    (state) => state.settingsData.copyOfcurrentOpenMenuItem
  );
  const userImageRedux = useSelector((state) => state.userData.userImage);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = React.useState();
  const globalLoading = useSelector(
    (state) => state.settingsData.globalLoading
  );
  const isopensidemenu = useSelector(
    (state) => state.settingsData.isopensidemenu
  );
  const showAppListOfUpdates = useSelector(
    (state) => state.settingsData.showAppListOfUpdates
  );
  const handleDrawerOpen = () => {
    setOpen(true);
    dispatch(setIsOpenSideMenu(true));
  };
  const handleDrawerClose = () => {
    setOpen(false);
    dispatch(setIsOpenSideMenu(false));
  };
  const navigate = useNavigate();
  useEffect(() => {
    console.log("isopensidemenu", isopensidemenu);
    setOpen(isopensidemenu);
  }, [isopensidemenu]);

  const [pathsList, setPathList] = useState([
    {
      id: 1,
      roles: (roles) => roles && roles?.includes(70),
      name: "Dashboard",
      to: "Dashboard",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Dashboard"}</span>
            ) : (
              ""
            )
          }
        >
          <DashboardSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 4,
      roles: (roles) => roles && roles?.includes(29),
      name: "complain",
      to: "complain",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"complain"}</span>
            ) : (
              ""
            )
          }
        >
          <SmsFailedSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    // {
    //   id: 6,
    //   roles:(roles)=>true,
    //   name: "Installation",
    //   to: "Installation",
    //   component: "",
    //   icon:  (open) => (
    //     <Tooltip
    //       arrow
    //       placement="right"
    //       title={
    //         !open ? (
    //           <span style={{ fontFamily: "Cairo-Medium" }}>
    //             {"Installation"}
    //           </span>
    //         ) : (
    //           ""
    //         )
    //      }
    //     >
    //       <BeenhereIcon className="iconSideMenu" />
    //     </Tooltip>
    //   ),
    //   subLink: [],
    // },
    {
      id: 7,
      roles: (roles) => roles && roles?.includes(73),
      name: "Mizan List Status",
      to: "mizan_list_status",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Mizan List Status"}
              </span>
            ) : (
              ""
            )
          }
        >
          <AccountBalanceWalletIcon
            className="iconSideMenu"
            style={{
              transform: "rotate(270deg)",
            }}
          />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 19,
      roles: (roles) => roles && roles?.includes(74),
      name: "Transfer Notification",
      to: "transfer_notification",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Transfer Notification"}
              </span>
            ) : (
              ""
            )
          }
        >
          <SyncProblemOutlinedIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 30,
      roles: (roles) => roles && roles?.includes(74),
      name: "Notifications",
      to: "Notifications",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Notifications"}
              </span>
            ) : (
              ""
            )
          }
        >
          <NotificationsActiveIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 8,
      roles: (roles) => roles && roles?.includes(36),
      name: "Missions",
      to: "missions",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Missions"}</span>
            ) : (
              ""
            )
          }
        >
          <AssignmentSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 34,
      roles: (roles) => roles && roles?.includes(54),
      name: "Inventory Requests",
      to: "inventory-requests",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                Inventory Requests
              </span>
            ) : (
              ""
            )
          }
        >
          <InventoryIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 35,
      roles: (roles) => roles && roles?.includes(75),
      name: "SubMission OverTimes",
      to: "sub-mission-overtimes",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                SubMission OverTimes
              </span>
            ) : (
              ""
            )
          }
        >
          <AddTaskIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 9999,
      roles: (roles) =>
        roles &&
        (roles?.includes(51) ||
          roles?.includes(60) ||
          roles?.includes(76) ||
          roles?.includes(77) ||
          roles?.includes(78) ||
          roles?.includes(72)),
      name: "Administration",
      to: "",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Administration"}
              </span>
            ) : (
              ""
            )
          }
        >
          <AdminPanelSettingsIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [
        {
          id: 34,
          roles: (roles) => roles && roles?.includes(51),
          name: "Leave Requests",
          to: "leave-requests",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Leave Requests
                  </span>
                ) : (
                  ""
                )
              }
            >
              <MarkChatUnreadIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 345,
          roles: (roles) => roles && roles?.includes(60),
          name: "User OverTimes",
          to: "user-overtimes",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    User OverTimes
                  </span>
                ) : (
                  ""
                )
              }
            >
              <WorkHistoryIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 353,
          roles: (roles) => roles && roles?.includes(76),
          name: "Car Inspections",
          to: "car_inspections",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Car Inspections
                  </span>
                ) : (
                  ""
                )
              }
            >
              <ArticleIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2,
          roles: (roles) => roles && roles?.includes(77),
          name: "Inspection Categories",
          to: "car_inspections_categories",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Inspections Categories
                  </span>
                ) : (
                  ""
                )
              }
            >
              <GridViewIcon className="iconSideMenu" />
            </Tooltip>
          ),
        },
        {
          id: 3,
          roles: (roles) => roles && roles?.includes(78),
          name: "Inspection Questions",
          to: "car_inspections_questions",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Inspections Questions
                  </span>
                ) : (
                  ""
                )
              }
            >
              <QuestionMarkIcon className="iconSideMenu" />
            </Tooltip>
          ),
        },
        {
          id: 4,
          roles: (roles) => roles && roles?.includes(72),
          name: "Attendances",
          to: "attendances",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Inspections Questions
                  </span>
                ) : (
                  ""
                )
              }
            >
              <FingerprintIcon className="iconSideMenu" />
            </Tooltip>
          ),
        },
      ],
    },
    {
      id: 9,
      roles: (roles) =>
        roles &&
        (roles?.includes(32) ||
          roles?.includes(33) ||
          roles?.includes(79) ||
          roles?.includes(80) ||
          roles?.includes(81)),
      name: "Tasks",
      to: "",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Tasks"}</span>
            ) : (
              ""
            )
          }
        >
          <span>
            <BsIcons.BsFillCollectionFill className="iconSideMenu" />
          </span>
        </Tooltip>
      ),
      subLink: [
        {
          id: 10,
          roles: (roles) => roles && roles?.includes(79),
          name: "General And Archived Tasks",
          to: "general_tasks",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"General Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <MdIcons.MdApps className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 11,
          roles: (roles) => roles && roles?.includes(80),
          name: "Installation Tasks",
          to: "installation_tasks",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Installation Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <GiIcons.GiGearHammer className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 12,
          roles: (roles) => roles && roles?.includes(81),
          name: "Customer Care Tasks",
          to: "customer_care_tasks",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Customer Care Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <MdIcons.MdOutlineHeadsetMic className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        // {
        //   id: 13,
        //   roles: (roles) => true,
        //   name: "Archived Tasks",
        //   to: "Tasks",
        //   component: "",
        //   ref:useRef(null),
        //   icon: (open) => (
        //     <Tooltip
        //       arrow
        //       placement="right"
        //       title={
        //         !open ? (
        //           <span style={{ fontFamily: "Cairo-Medium" }}>
        //             {"Archived Tasks"}
        //           </span>
        //         ) : (
        //           ""
        //         )
        //       }
        //     >
        //       <AiIcons.AiOutlineFileZip className="iconSideMenu" />
        //     </Tooltip>
        //   ),
        //   subLink: [],
        // },
        {
          id: 32,
          roles: (roles) => roles && roles?.includes(33),
          name: "Task Summary Dashboard",
          to: "task_summary_dashboard",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Archived Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <SiIcons.SiSimpleanalytics className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 33,
          roles: (roles) => roles && roles?.includes(32),
          name: "Customer Care E&I Reports",
          to: "customer_care_reports",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Archived Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <AiIcons.AiFillFileText className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 34,
          roles: (roles) => roles && roles?.includes(79),
          name: "Finances",
          to: "finances",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"General Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <PaidIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 35,
          roles: (roles) => roles && roles?.includes(79),
          name: "Units Transfer",
          to: "units_transfer",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"General Tasks"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <TbTransfer className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
      ],
    },
    {
      id: 14,
      roles: (roles) => roles && roles?.includes(27),
      name: "Planning",
      to: "",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Planning"}</span>
            ) : (
              ""
            )
          }
        >
          <span>
            <BsIcons.BsCalendar2Week className="iconSideMenu" />
          </span>
        </Tooltip>
      ),
      subLink: [
        {
          id: 18,
          roles: (roles) => roles && roles?.includes(27),
          name: "Drag And Drop Missions",
          to: "dnd_missions",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>{"Drag And Drop Missions"}</span>
                ) : (
                  ""
                )
              }
            >
              <PanToolAlt className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 15,
          roles: (roles) => roles && roles?.includes(27),
          name: "Unavailable Resources",
          to: "unavailable_resources",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Unavailable Resources"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BsIcons.BsShieldSlash className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 16,
          roles: (roles) => roles && roles?.includes(27),
          name: "Create Mission",
          to: "create_mission",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Create Mission"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <AiIcons.AiOutlineAppstoreAdd className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 17,
          roles: (roles) => roles && roles?.includes(27),
          name: "Daily Plan",
          to: "daily_plan",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Daily Plan"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <AiIcons.AiOutlineLineChart className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 19,
          roles: (roles) => roles && roles?.includes(106),
          name: "Warsha plans",
          to: "warsha_plans",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Warsha plans"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <HomeRepairServiceIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
      ],
    },
    {
      id: 2323,
      roles: (roles) => roles && (roles?.includes(64) || roles?.includes(68)),
      name: "Documentation",
      to: "",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Documentation"}
              </span>
            ) : (
              ""
            )
          }
        >
          <FolderCopyIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [
        {
          id: 2324,
          roles: (roles) => roles && roles?.includes(64),
          name: "System files",
          to: "files",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    System files
                  </span>
                ) : (
                  ""
                )
              }
            >
              <DescriptionIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2325,
          roles: (roles) => roles && roles?.includes(68),
          name: "Classifications Tree View",
          to: "classifications-tree-view",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Classifications Tree View
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BiIcons.BiCategory className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2325,
          roles: (roles) => roles && roles?.includes(68),
          name: "Classifications",
          to: "classifications",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Classifications
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BiIcons.BiCategory className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2326,
          roles: (roles) => roles && roles?.includes(68),
          name: "Classifications Level 1",
          to: "classifications-level-1",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Classifications Level 1
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BiIcons.BiCategory className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2326,
          roles: (roles) => roles && roles?.includes(68),
          name: "Classifications Level 2",
          to: "classifications-level-2",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Classifications Level 2
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BiIcons.BiCategory className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2327,
          roles: (roles) => roles && roles?.includes(68),
          name: "Classifications Level 3",
          to: "classifications-level-3",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Classifications Level 3
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BiIcons.BiCategory className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 2328,
          roles: (roles) => roles && roles?.includes(68),
          name: "Classifications Level 4",
          to: "classifications-level-4",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Classifications Level 4
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BiIcons.BiCategory className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 21,
          roles: (roles) => roles && roles?.includes(64),
          name: "File Manager",
          to: "file_manager",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    {"Mizan List Status"}
                  </span>
                ) : (
                  ""
                )
              }
            >
              <FolderIcon
                className="iconSideMenu"
              />
            </Tooltip>
          ),
          subLink: [],
        },
      ],
    },
    {
      id: 18,
      roles: (roles) => roles && (roles?.includes(30) || roles?.includes(82) || roles?.includes(11) || roles?.includes(72) || roles?.includes(71) || roles?.includes(86)),
      name: "Masters",
      to: "",
      component: "",
      ref: useRef(null),
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Masters"}</span>
            ) : (
              ""
            )
          }
        >
          <ViewListIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [
        {
          id: 2,
          roles: (roles) => roles && roles?.includes(71),
          name: "Users",
          to: "Users",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>{"Users"}</span>
                ) : (
                  ""
                )
              }
            >
              <PeopleAltSharpIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 3,
          roles: (roles) => roles && roles?.includes(72),
          name: "Department",
          to: "Department",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>{"Department"}</span>
                ) : (
                  ""
                )
              }
            >
              <AppsSharpIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 5,
          roles: (roles) => roles && roles?.includes(11),
          name: "Task Type",
          to: "Task_type",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>{"Task Type"}</span>
                ) : (
                  ""
                )
              }
            >
              <BookmarkAddedSharpIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 5,
          roles: (roles) => roles && roles?.includes(11),
          name: "Finance Type",
          to: "finance_type",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>{"Task Type"}</span>
                ) : (
                  ""
                )
              }
            >
              <PriceChangeIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 19,
          roles: (roles) => roles && roles?.includes(30),
          name: "Request Types",
          to: "request_types",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Request Types
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BsIcons.BsCollectionFill className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 20,
          roles: (roles) => roles && roles?.includes(82),
          name: "Vehicles Master",
          to: "vehicle_master",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Request Types
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BsIcons.BsTruck className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 366655,
          roles: (roles) => roles && roles?.includes(86),
          name: "Groups",
          to: "groups",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Groups
                  </span>
                ) : (
                  ""
                )
              }
            >
              <GroupsIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 366657,
          roles: (roles) => roles && roles?.includes(97),
          name: "Link Images",
          to: "image-submission-type",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    Link Images
                  </span>
                ) : (
                  ""
                )
              }
            >
              <LinkIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 366658,
          roles: (roles) => roles && roles?.includes(99),
          name: "SUBM Image Types",
          to: "submission-image-types",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                    SUBM Image Types
                  </span>
                ) : (
                  ""
                )
              }
            >
              <BurstModeIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
        {
          id: 366659,
          roles: (roles) => roles && roles?.includes(100),
          name: "Submission Types",
          to: "submission-types",
          component: "",
          ref: useRef(null),
          icon: (open) => (
            <Tooltip
              arrow
              placement="right"
              title={
                !open ? (
                  <span style={{ fontFamily: "Cairo-Medium" }}>
                   Submission Types
                  </span>
                ) : (
                  ""
                )
              }
            >
              <AutoAwesomeMotionIcon className="iconSideMenu" />
            </Tooltip>
          ),
          subLink: [],
        },
      ],
    },
    // {
    //   id: 20,
    //   roles: (roles) => true,
    //   name: "Settings",
    //   to: "",
    //   component: "",
    //   icon: (open) => (
    //     <Tooltip
    //       arrow
    //       placement="right"
    //       title={
    //         !open ? (
    //           <span style={{ fontFamily: "Cairo-Medium" }}>{"Settings"}</span>
    //         ) : (
    //           ""
    //         )
    //       }
    //     >
    //       <AiIcons.AiOutlineSetting className="iconSideMenu" />
    //     </Tooltip>
    //   ),
    //   subLink: [
    //     {
    //       id: 21,
    //       roles: (roles) => true,
    //       name: "Default Settings",
    //       to: "default_settings",
    //       component: "",
    //       icon: (open) => (
    //         <Tooltip
    //           arrow
    //           placement="right"
    //           title={
    //             !open ? (
    //               <span style={{ fontFamily: "Cairo-Medium" }}>
    //                 Default Settings
    //               </span>
    //             ) : (
    //               ""
    //             )
    //           }
    //         >
    //           <AiIcons.AiOutlineStar className="iconSideMenu" />
    //         </Tooltip>
    //       ),
    //       subLink: [],
    //     },
    //     // {
    //     //   id: 33,
    //     //   roles: (roles) => true,
    //     //   name: "User Profile",
    //     //   to: "user-profile",
    //     //   component: "",
    //     //   icon: (open) => (
    //     //     <Tooltip
    //     //       arrow
    //     //       placement="right"
    //     //       title={
    //     //         !open ? (
    //     //           <span style={{ fontFamily: "Cairo-Medium" }}>
    //     //             User Profile
    //     //           </span>
    //     //         ) : (
    //     //           ""
    //     //         )
    //     //       }
    //     //     >
    //     //       <PersonIcon className="iconSideMenu" />
    //     //     </Tooltip>
    //     //   ),
    //     //   subLink: [],
    //     // },
    //   ],
    // },
    // {
    //   id: 22,
    //   roles:(roles)=>true,
    //   name: "Customers",
    //   to: "/customers",
    //   component: "",
    //   icon:  (open) => (
    //     <Tooltip
    //       arrow
    //       placement="right"
    //       title={
    //         !open ? (
    //           <span style={{ fontFamily: "Cairo-Medium" }}>
    //            customers
    //           </span>
    //         ) : (
    //           ""
    //         )
    //      }
    //     >
    //       <AiIcons.AiOutlineStar className="iconSideMenu" />
    //     </Tooltip>
    //   ),
    //   subLink: [],
    // },
    // {
    //   id: 23,
    //   roles:(roles)=>true,
    //   name: "Notifications",
    //   to: "/notifications",
    //   component: "",
    //   icon:  (open) => (
    //     <Tooltip
    //       arrow
    //       placement="right"
    //       title={
    //         !open ? (
    //           <span style={{ fontFamily: "Cairo-Medium" }}>
    //            Notifications
    //           </span>
    //         ) : (
    //           ""
    //         )
    //      }
    //     >
    //       <AiIcons.AiOutlineStar className="iconSideMenu" />
    //     </Tooltip>
    //   ),
    //   subLink: [],
    // },
  ]);

  const getUserImage = () => {
    return userInfo?.hasImage
      ? userInfo.img_url
      : "https://dev.chromeandwhyte.com/wp-content/uploads/2022/07/User-Profile-PNG.png";
  };

  const logout = () => {
    if (cookies.get("token")) cookies.remove("token", { path: "/" });
    if (cookies.get("language")) cookies.remove("language", { path: "/" });
    if (cookies.get("access_type"))
      cookies.remove("access_type", { path: "/" });
    localStorage.removeItem("userImage");
    window.location.href = "/";
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openSearchBox = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  var checkName = "";
  const getAppBarTitle = (data) => {
    data &&
      data?.length > 0 &&
      data?.map((itm) => {
        if (itm?.subLink?.length > 0) {
          getAppBarTitle(itm?.subLink);
        } else {
          if ("/ticket-system/" + itm?.to == window.location.pathname) {
            console.log(
              "pathname",
              window.location.pathname,
              "...",
              "/ticket-system/" + itm?.to
            );
            checkName = itm?.name;
          }
        }
      });
    console.log("nameroute", checkName);
    if (!checkName && pageTitle) {
      checkName = pageTitle;
    }
    return checkName;
    // setAppBarTitle(checkName)
  };

  const getUserImageURL = () => {
    let temImage = userTemImage;
    if (userImageRedux) {
      temImage = host + userImageRedux;
    }
    return temImage;
  };

  const handleOpenClosedMenu = () => {
    if (pathsList && pathsList.length) {
      console.log("asdasdasdsadasdsad", window.location.pathname);
      var arr = [],
        checkExsts = false;
      pathsList?.map((item) => {
        if (item?.subLink?.length > 0) {
          let find = item?.subLink?.find((subItem) => {
            console.log("asdasdasdsadasdsad", ("/ticket-system/" + subItem?.to) + "---" + window.location.pathname);
            if ("/ticket-system/" + subItem?.to === window.location.pathname) {
              return true;
            } else return false;
          });
          if (find) {
            checkExsts = true;
            arr.push({
              ...item,
              show: true,
            });
          } else {
            arr.push(item);
          }
        } else {
          arr.push(item);
        }
      });
      if (checkExsts) {
        // dispatch(setPathNameClicked(false))
        setPathList(arr);
      }
    }
  }

  return (
    <Box sx={{ display: "flex", transition: "width 0.3s ease !important" }}>
      <CssBaseline />
      {!open_advance_search ? <SideSetting /> : null}
      {!open_advance_search?<AppListOfUpdates />:null}
      <PopupSearch
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        open={openSearchBox}
        handleClick={handleClick}
        handleClose={handleClose}
      />
      <AppBar
        position="fixed"
        open={isopensidemenu}
        drawerwidth={drawerwidth}
        sidemenutheme={sidemenutheme}
        appbarTheme={appbarTheme}
      >
        <Box
          sx={{
            display: "flex",
            // justifyContent: "space",
            alignItems: "center",
            width: "100% !important",
          }}
          onClick={() => {
            dispatch(setIsOpenSideMenu(false));
          }}
        >
          <AppBarItems
            logout={logout}
            getTitle={() => getAppBarTitle(pathsList)}
            open={isopensidemenu}
          />
        </Box>
      </AppBar>
      <Drawer
        variant="permanent"
        open={isopensidemenu}
        drawerwidth={drawerwidth}
        sidemenutheme={sidemenutheme}
      >
        <IconButton
          onClick={() => {
            setOpen(!open);
            dispatch(setIsOpenSideMenu(!isopensidemenu));
            if (!isopensidemenu) {
              dispatch(setCurrentlyOpendMenuItem(copyOfcurrentOpenMenuItem))
              handleOpenClosedMenu()
            }
          }}
          sx={{
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            border: "1px dashed rgba(145, 158, 171, 0.24)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "30px",
            right: "-12.5px",
            zIndex: "1222",
            "& .MuiSvgIcon-root": {
              width: "19px",
              height: "19px",
            },
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: "#fff",
            },
          }}
        >
          {isopensidemenu ? <KeyboardArrowLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
        <IconButton
          id="basic-button"
          aria-controls={openSearchBox ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openSearchBox ? "true" : undefined}
          onClick={handleClick}
          sx={{
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            border: "1px dashed rgba(145, 158, 171, 0.24)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "60px",
            right: "-12.5px",
            zIndex: "1222",
            backgroundColor: "#fff",
            "& .MuiSvgIcon-root": {
              width: "19px",
              height: "19px",
            },
            "&:hover": {
              backgroundColor: "#fff",
            },
          }}
        >
          <SearchIcon sx={{ size: 12 }} size={12} />
        </IconButton>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: isopensidemenu ? "flex-start" : "center",
            alignItems: "center",
            marginTop: "17px",
            paddingLeft: isopensidemenu ? "20px" : "0px",
          }}
        >
          <img
            src={!isopensidemenu ? logo : logo}
            style={{
              width: !isopensidemenu ? "30px" : "52px",
              height: !isopensidemenu ? "30px" : "48px",
              objectFit: "cover",
              backgroundSize: "center center",
            }}
          />
        </Box>
        {isopensidemenu ? (
          <Box
            sx={{
              marginTop: "40px",
              width: "96.4%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => {
              navigate("/ticket-system/user-profile");
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                backgroundColor: "#F2F3F5",
                width: "90%",
                borderRadius: "5px",
                padding: "10px 4px",
                boxShadow: "0px 0px 5px -3px rgb(0 0 0 / 75%)",
                WebkitBoxShadow: "0px 0px 5px -3px rgb(0 0 0 / 75%)",
                MozBoxShadow: "0px 0px 5px -3px rgb(0 0 0 / 75%)",
                cursor: "pointer",
                transition: "0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "0 5px 10px -1px #1e6a99",
                },
                "&:hover .containerOfImage": {
                  border: "2px solid #FF3970",
                },
              }}
            >
              <Box
                className="containerOfImage"
                sx={{
                  backgroundColor: "rgb(223,226,231)",
                  // padding: "10px",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 15px",
                  overflow: "hidden",
                  transition: "0.3s ease-in-out",
                  "& img": {
                    objectFit: "cover !important",
                  },
                }}
              >
                <img
                  src={getUserImageURL()}
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    backgroundSize: "center center",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <span style={{ fontFamily: "Cairo-Bold", color: "#000" }}>
                  {localStorage?.getItem("userData")
                    ? JSON.parse(localStorage?.getItem("userData"))?.username
                    : ""}
                </span>
                <span
                  style={{
                    fontFamily: "Cairo-Bold",
                    fontSize: "13px",
                    color: "gray",
                  }}
                >
                  {localStorage?.getItem("userData")
                    ? JSON.parse(localStorage?.getItem("userData"))?.email
                    : ""}
                </span>
              </Box>
            </Box>
          </Box>
        ) : null}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "space-between",
            width: "100%",
            height: "100%",
            // overflowY:'scroll',
            overflow: "hidden",
            marginTop: !isopensidemenu ? "20px" : "0",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              overflowY: "auto !important",
              overflowX: "hidden",
              transition: "all 0.3s ease-in-out",
              scrollBehavior: "smooth",
              "&:hover": {
                // overflowY: "auto",
              },
            }}
            ref={MainContainerRef}
          >
            <SideMenuItemArray
              open={isopensidemenu}
              setOpen={(value) => {
                dispatch(setIsOpenSideMenu(value));
              }}
              pathsList={pathsList}
              setPathList={setPathList}
              MainContainerRef={MainContainerRef}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: isopensidemenu ? "start" : "center",
              flexDirection: "column",
              width: "90%",
              alignItems: isopensidemenu ? "start" : "center",
              "& .iconSideMenu": {
                color: `${sidemenutheme?.iconColor}`,
                fontSize: "28px",
              },
              "& .MuiListItemText-root .Mui51Typography-root,& .logout": {
                textAlign: "left",
                font: "normal normal 15px/30px Cairo-Medium !important",
                letterSpacing: "0px",
                color: "#52575D",
                opacity: "1",
              },
              "& .logout": {
                margin: "0 7px !important",
                position: "relative",
                top: "-2px",
                color: "#fff !important",
              },
              transition: "width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
            }}
          >
            <Divider
              sx={{
                width: !isopensidemenu ? "60%" : "95%",
                height: "3px",
                background: "#EBF2F7 0% 0% no-repeat padding-box",
                margin: "0px auto",
                marginTop: "5px",
                // marginRight:open?0:'15px',
                opacity: "1",
                marginLeft: isopensidemenu ? "15px" : "17px",
                display: "flex",
                // alignSelf:'center'
              }}
            />

            <Box
              sx={{
                marginLeft: !isopensidemenu ? "3px" : "14px",
                padding: "5px 10px",
                display: "flex !important",
                justifyContent: isopensidemenu ? "start" : "center",
                alignItems: "center",
                cursor: "pointer",
                width: isopensidemenu ? "100%" : "35px",
                height: isopensidemenu ? "45px" : "35px",
                borderRadius: isopensidemenu ? "5px" : "50%",
                backgroundColor: "#ff3744",
                marginTop: "5px",
              }}
              onClick={logout}
            >
              <Tooltip
                arrow
                placement="right"
                title={
                  !open ? (
                    <span style={{ fontFamily: "Cairo-Medium" }}>
                      {"Log out"}
                    </span>
                  ) : (
                    ""
                  )
                }
              >
                <LogoutIcon
                  // sx={{ transform: " matrix(-1, 0, 0, -1, 0, 0)" }}
                  className="iconSideMenu"
                  sx={{ color: "#fff !important", fontSize: "23px !important" }}
                />
              </Tooltip>

              {isopensidemenu ? (
                <span
                  className="logout"
                  sx={{
                    opacity: isopensidemenu ? 1 : 0,
                    margin: "0 10px !important",
                    color: "#fff",
                  }}
                >
                  Log out
                </span>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: 3,
          py: 1,
          marginTop: "0px",
          backgroundColor: "transparent",
          // paddingRight:0,
          // paddingLeft:0,
          minWidth: "900px !important",
        }}
        onClick={() => {
          dispatch(setIsOpenSideMenu(false));
        }}
      >
        {globalLoading ? <Preloading /> : null}
        <Outlet />
      </Box>
      {/* <Tooltip title="Grid Settings">
        <Box
          sx={{
            position: "absolute",
            zIndex: 100,
            bottom: 25,
            right: 20,
            backgroundColor: "#fff",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            boxShadow: "0 0 12px -2px #000000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            cursor: "pointer",
            transition: "transform 0.3s ease-in-out",
            "&:hover": {
              backgroundColor: "#d8f0ff",
              border: "2px solid #fff",
            },
            "&:hover svg": {
              transform: "scale(1.12)",
            },
          }}
          onClick={() => {
            dispatch(setOpenSideSetting(true));
          }}
        >
          <ToggleOnIcon
            sx={{
              color: "#1e6a99",
              position: "relative",
              top: "5px",
            }}
          />
          <ToggleOffIcon
            sx={{
              color: "#1e6a999c",
              position: "relative",
              top: "-5px",
            }}
          />
        </Box>
      </Tooltip> */}
    </Box>
  );
}
